import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  message: string;
}

interface State {
}

export default class SuccessModal extends React.PureComponent<Props, State> {
  render(): React.ReactNode {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={() => this.props.toggle()}
        centered={true}
        className="unsaved-modal"
      >
        <ModalBody className="pb-0">
          <h2>{this.props.message}</h2>
        </ModalBody>

        <ModalFooter>
          <Button
            color={'primary'}
            className='btn btn-primary'
            onClick={() => this.props.toggle()}
          >
            OK
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
